import { AllTypeResourcesData } from "@/store/resources-grid/utils/types/resources";
import { CleanActionTypes } from "@/utils/clean-options";
import { PutUsersMeAccountsByAccountIdResourcesApiArg } from "@/services/cloudchipr.api";

const getResourceCleanActionType = (action: CleanActionTypes) => {
  if (action === "start") {
    return "start";
  }

  if (action === "stop") {
    return "stop";
  }

  if (action === "reboot") {
    return "reboot";
  }

  return "terminate";
};

export const generateCleanData = (
  resources: AllTypeResourcesData[],
  cleanAction: CleanActionTypes,
) => {
  return resources?.map(({ resource }) => {
    const providerUniqueIdentifier =
      "provider_unique_identifier" in resource
        ? resource.provider_unique_identifier
        : "";

    return {
      id: resource.id,
      type: resource.resource_type,
      action: getResourceCleanActionType(cleanAction),
      snapshot: cleanAction === "snapshot_and_delete",
      provider_unique_identifier: providerUniqueIdentifier,
    };
  }) as PutUsersMeAccountsByAccountIdResourcesApiArg["body"];
};
